var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container form-container"},[_c('div',{staticClass:"box"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.signupForm($event)}}},[_c('b-field',{attrs:{"label":"Email","type":{
                        'is-danger':
                            _vm.hasError.emailNotUnique.status ||
                            _vm.hasError.emailNotEmpty.status,
                    },"message":[
                        {
                            'Email already registered':
                                _vm.hasError.emailNotUnique.status,
                            'Email cannot empty':
                                _vm.hasError.emailNotEmpty.status,
                        } ]}},[_c('b-input',{attrs:{"type":"email","maxlength":"30"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_c('b-field',{attrs:{"label":"Password","type":{
                        'is-danger':
                            _vm.hasError.passwordMinLength.status ||
                            _vm.hasError.passwordNotEmpty.status,
                    },"message":[
                        {
                            'Password must have at least 6 characters':
                                _vm.hasError.passwordMinLength.status,
                            'Password cannot empty':
                                _vm.hasError.passwordNotEmpty.status,
                        } ]}},[_c('b-input',{attrs:{"type":"password","password-reveal":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_c('b-field',{staticClass:"mt-5"},[_c('b-button',{attrs:{"native-type":"submit","type":"is-primary","expanded":""}},[_vm._v("Sign up")])],1)],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }